// TDS (Toss Design System) 디자인 토큰
// 토스 스타일 가이드 기반 색상, 타이포그래피, 간격, 라운딩
// 2026-04-19: ClaudeDesign 디자인 시스템과 값 정렬 (design-system/colors_and_type.css 기준)

export const TDS = {
  color: {
    // Primary
    blue: '#3182F6',
    blue50: '#E8F3FF',
    blue100: '#C9E2FF',
    blue500: '#3182F6',
    blue600: '#2272EB',

    // Gray scale
    gray50: '#F9FAFB',
    gray100: '#F2F4F6',
    gray200: '#E5E8EB',
    gray300: '#D1D6DB',
    gray400: '#B0B8C1',
    gray500: '#8B95A1',
    gray600: '#6B7684',
    gray700: '#4E5968',
    gray800: '#333D4B',
    gray900: '#191F28',

    // Semantic
    white: '#FFFFFF',
    black: '#191F28',
    red: '#F04452',
    redAlt: '#E42939',
    green: '#03B26C',
    yellow: '#FFC342',
    orange: '#FE9800',

    // Background
    bgPrimary: '#FFFFFF',
    bgSecondary: '#F9FAFB',
    bgTertiary: '#F2F4F6',

    // Text
    textPrimary: '#191F28',
    textSecondary: '#4E5968',
    textTertiary: '#8B95A1',
    textDisabled: '#B0B8C1',
    textWhite: '#FFFFFF',
  },

  typography: {
    // Heading
    h1: { fontSize: '26px', fontWeight: 700, lineHeight: 1.35 },
    h2: { fontSize: '22px', fontWeight: 700, lineHeight: 1.35 },
    h3: { fontSize: '18px', fontWeight: 700, lineHeight: 1.4 },

    // Body — t5 (17px)는 CTA/섹션 타이틀 용도로 디자인 기준에 맞춰 추가
    t5: { fontSize: '17px', fontWeight: 400, lineHeight: '25.5px' },
    t5SemiBold: { fontSize: '17px', fontWeight: 600, lineHeight: '25.5px' },
    t5Bold: { fontSize: '17px', fontWeight: 700, lineHeight: '25.5px' },
    body1: { fontSize: '16px', fontWeight: 400, lineHeight: 1.5 },
    body1Medium: { fontSize: '16px', fontWeight: 500, lineHeight: 1.5 },
    body1Bold: { fontSize: '16px', fontWeight: 600, lineHeight: 1.5 },
    body2: { fontSize: '15px', fontWeight: 400, lineHeight: 1.5 },
    body2Bold: { fontSize: '15px', fontWeight: 600, lineHeight: 1.5 },
    body3: { fontSize: '14px', fontWeight: 400, lineHeight: 1.5 },
    body3Bold: { fontSize: '14px', fontWeight: 600, lineHeight: 1.5 },

    // Caption
    caption1: { fontSize: '13px', fontWeight: 400, lineHeight: 1.4 },
    caption1Bold: { fontSize: '13px', fontWeight: 600, lineHeight: 1.4 },
    caption2: { fontSize: '12px', fontWeight: 400, lineHeight: 1.4 },
    caption2Bold: { fontSize: '12px', fontWeight: 600, lineHeight: 1.4 },
    // chip label (st12: 12px medium) — Chip/소형 태그 전용 스케일
    chipLabel: { fontSize: '12px', fontWeight: 500, lineHeight: 1.4 },

    // Small
    small: { fontSize: '11px', fontWeight: 400, lineHeight: 1.3 },
    smallBold: { fontSize: '11px', fontWeight: 600, lineHeight: 1.3 },
    // badge (mini: 10px bold) — Seat 배지 등 초소형
    mini: { fontSize: '10px', fontWeight: 700, lineHeight: 1.5 },
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
    xxxl: 32,
    // Semantic spacing (디자인 기준 레이아웃 상수)
    screenPadX: 20,
    screenPadXWide: 24,
    safeBottom: 34,
  },

  radius: {
    sm: '8px',       // 썸네일
    md: '12px',      // 칩, 인풋, 카드
    lg: '16px',      // CTA 버튼
    xl: '20px',      // (레거시 — 새 화면에서는 xxl 사용)
    xxl: '28px',     // 바텀시트
    full: '9999px',
  },
} as const;
